import { ActionsUnion, createAction } from "../definitions";
import { UserHosRuleSetActionTypes } from "./types";
import UserHosRuleSet from "../../model/UserHosRuleSet";

export interface IUserHosRuleSetPayload {
    userId: string;
    userHosRuleSets: IIdDictionary<UserHosRuleSet>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const UserHosRuleSetActions = {
    setUserHosRuleSets: (payload: IUserHosRuleSetPayload) => createAction(UserHosRuleSetActionTypes.SET_USER_HOS_RULESETS, payload),
    clearUserHosRuleSets: (payload?: string) => createAction(UserHosRuleSetActionTypes.CLEAR_USER_HOS_RULESETS, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type UserHosRuleSetActions = ActionsUnion<typeof UserHosRuleSetActions>;